import { generatedIamApi } from './api/endpoints.gen';

export const { useGetDisplayMappingQuery } = generatedIamApi;
